
var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var customAnalytics = require('custom-analytics');

var dom = {};

var playerOrigin = '*';

var activateLogging = true;

var writeLog = function(data){

	if(activateLogging){
		console.log(data);
	}

};

var setupDom = function(){

	dom.player = $('iframe');
	dom.status = $('.status');

};

var addEventHandlers = function(){

	// Call the API when a button is pressed
	$('button').on('click', function() {
		post($(this).text().toLowerCase());
	});

	// Listen for messages from the player
	if (window.addEventListener) {
		window.addEventListener('message', onMessageReceived, false);
	}
	else {
		window.attachEvent('onmessage', onMessageReceived, false);
	}

};

// Handle messages received from the player
var onMessageReceived = function(event) {
	// Handle messages from the vimeo player only
	if (!(/^https?:\/\/player.vimeo.com/).test(event.origin)) {
		return false;
	}
	
	if (playerOrigin === '*') {
		playerOrigin = event.origin;
	}
	
	var data = JSON.parse(event.data);
	
	switch (data.event) {
		case 'ready':
			onReady();
			break;

		case 'play':

			onPlay(data.data);
			break;
		   
		case 'playProgress':
			onPlayProgress(data.data);
			break;
			
		case 'pause':
			onPause();
			break;
		   
		case 'finish':
			onFinish();
			break;
	}
};

// Helper function for sending a message to the player
var post = function(action, value) {
	var data = {
	  method: action
	};
	
	if (value) {
		data.value = value;
	}
	
	var message = JSON.stringify(data);
	dom.player[0].contentWindow.postMessage(data, playerOrigin);
};

var onReady = function() {

	writeLog('ready');
	
	post('addEventListener', 'pause');
	post('addEventListener', 'finish');
	post('addEventListener', 'play');
	post('addEventListener', 'playProgress');
};

var onPause = function() {
	writeLog('pause fired');
};

var onFinish = function() {
	writeLog('play fired');
};

var onPlay = function(data) {
	writeLog('play fired');

	customAnalytics.transmitData({
		'event': 'custom_event',
		'eventCategory': 'video',
		'eventAction': 'video played',
		'eventLabel': pbizCorporateServer.product.name,
		'eventValue': undefined
	});
};

var onPlayProgress = function(data) {
	// writeLog(data.seconds + 's played');
};

var init = function(){

	setupDom();

	addEventHandlers();

};

$(init);